export default {
	setUser(state, payload) {
		state.token = payload.token;
		state.userId = payload.userId;
		state.email = payload.email;
	},
	setUserInfo(state, payload) {
		state.firstName = payload.firstName;
		state.lastName = payload.lastName;
		state.number = payload.number
		state.userType = payload.userType;
		state.league = payload.league;
		state.leagueId = payload.leagueId;
		state.team = payload.team;
		state.teamId = payload.teamId;
		state.positions = payload.positions;
		state.divisionId = payload.divisionId;
		state.division = payload.division;
	},
	setUserLeague(state, payload) {
		state.league = payload.league;
		state.leagueId = payload.leagueId;
		state.divisionId = payload.divisionId;
		state.division = payload.division;
	},
	setUserTeam(state, payload) {
		state.team = payload.userTeam;
	},
	setAllUsers(state, payload) {
		state.usersList = payload;
	},
	updateComponent(state, payload) {
		state.updateComponent = payload + 1;
	},
	setAutoLogout(state) {
		state.didAutoLogout = true;
	},
};
